import { useBetslipStore } from "@/features/betslip/stores/betslipStore";

export const useIsPermittedToBet = (outcomeId: string): boolean =>
  useBetslipStore((state) => !state.notPermittedOutcomeIds.has(outcomeId));
